import { dateToYYMMDD, parseDateYYYYMMDD } from '@mummssoftware/utils/dates';
import { flowRight as compose } from 'lodash-es';
import { formatTeamLabel, IDGMeeting } from './transforms';
import defaults from '../../translations/en.json';

// ---------------------------------------------------------------------------
// Shared defaults
// ---------------------------------------------------------------------------

export const commonColumnDefs = {
  sortable: true,
  filter: false,
  resizable: true,
};

// ---------------------------------------------------------------------------
// Date formatting
// ---------------------------------------------------------------------------

const formatDate = compose(dateToYYMMDD, parseDateYYYYMMDD);

const formatAgendaDates = ({ fromDate, toDate }: IDGMeeting): string => {
  const from = fromDate ? formatDate(fromDate) : '';
  const to = toDate ? formatDate(toDate) : '';
  if (from && to) return `${from} \u2013 ${to}`;
  return from || to || defaults.meetingFallback;
};

// ---------------------------------------------------------------------------
// Master row columns (IDGMeeting)
// ---------------------------------------------------------------------------

const TeamNameExpanded = {
  colId: 'teamName',
  headerName: defaults.columnTeamName,
  valueGetter: (params: any) => formatTeamLabel(params.data as IDGMeeting),
  cellRenderer: 'agGroupCellRenderer',
  flex: 1,
  minWidth: 140,
};

const TeamNameSmall = {
  colId: 'teamName',
  headerName: defaults.columnTeamName,
  valueGetter: (params: any) => formatTeamLabel(params.data as IDGMeeting),
  flex: 1,
  minWidth: 140,
};

const AgendaDates = {
  headerName: defaults.columnAgendaDates,
  colId: 'agendaDates',
  valueGetter: (params: any) => formatAgendaDates(params.data as IDGMeeting),
  flex: 1,
  minWidth: 140,
};

export const getMasterColumnDefs = (smallWidget?: boolean) =>
  smallWidget ? [TeamNameSmall, AgendaDates] : [TeamNameExpanded, AgendaDates];
